<template>
	<div
		class="overflow-xh-ya pl-2"
		:class="{
			'mt-3': !editAsset,
		}"
	>
		<b-row
			:class="{
				'mt-3': !editAsset,
			}"
		>
			<b-col class="mr-3">
				<TextField
					text="Title"
					placeholder="Enter"
					modelKey="$model"
					:maxLength="150"
					:modelValue="validation.title"
					:error="validation.title.$error"
				/>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="12" class="pr-3 assetbank-tags">
				<FormTags
					placeholder="e.g.,tutorial"
					:isMandatory="false"
					class="mr-3"
					modelKey="tags"
					:modelValue="linkData"
				/>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col class="mr-3">
				<TextField
					text="Link"
					placeholder="Enter"
					modelKey="$model"
					:modelValue="validation.link"
					:error="validation.link.$error"
				/>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	props: {
		linkData: {
			type: Object,
			required: true,
		},
		editAsset: {
			type: Boolean,
		},
		validation: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style>
.assetbank-tabs .assetbank-tags ul {
	width: 100%;
}
.assetbank-tabs .assetbank-tags ul li {
	width: fit-content;
}
</style>
